__turbopack_context__.v({
  "className": "caveat_456a203b-module__xHzzeG__className",
});
